import { createDecorator } from '../../../../../platform/instantiation/common/instantiation.js';
const INotebookEditorService = ( createDecorator('INotebookEditorWidgetService'));
export { INotebookEditorService };
